import { ConvexBetterAuthProvider } from "@convex-dev/better-auth/react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ConvexReactClient } from "convex/react";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App";
import { authClient } from "./lib/authClient";
import { getCachedConvexToken } from "./lib/cachedConvexToken";
import { initPostHog } from "./lib/posthog";

initPostHog();

const queryClient = new QueryClient();

const convexUrl = import.meta.env.VITE_CONVEX_URL;
if (typeof convexUrl !== "string" || !convexUrl) {
	throw new Error("Missing VITE_CONVEX_URL environment variable");
}
const convex = new ConvexReactClient(convexUrl, { expectAuth: true });
const cachedToken = getCachedConvexToken();

const app = (
	<StrictMode>
		<QueryClientProvider client={queryClient}>
			<ConvexBetterAuthProvider
				client={convex}
				// @ts-expect-error `@convex-dev/better-auth`'s `AuthClient` prop type is degenerate under better-auth 1.6 (its `useSession().data` infers as `never`), so a fully-typed client isn't assignable. Runtime is correct; drop this when upstream fixes the type. See get-convex/better-auth#195.
				authClient={authClient}
				initialToken={cachedToken}
			>
				<App />
			</ConvexBetterAuthProvider>
		</QueryClientProvider>
	</StrictMode>
);

const rootEl = document.getElementById("root");
if (!rootEl) throw new Error("Root element not found");
createRoot(rootEl).render(app);
